// Header Component
import { getCurrentUser, isAdmin } from '../auth.js';
import { t, getLanguage } from '../i18n.js';

export function renderHeader() {
  const user = getCurrentUser();

  // สร้างนาฬิกา
  setTimeout(() => {
    const clockEl = document.getElementById('global-clock');
    if (clockEl && !window._globalClockInt) {
      window._globalClockInt = setInterval(() => {
        const c = document.getElementById('global-clock');
        if (!c) return;
        const now = new Date();
        const dOpts = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric', timeZone: 'Asia/Bangkok' };
        const tOpts = { hour: '2-digit', minute: '2-digit', second: '2-digit', timeZone: 'Asia/Bangkok', hour12: false };
        const locale = getLanguage() === 'th' ? 'th-TH' : 'en-US';
        c.innerHTML = now.toLocaleDateString(locale, dOpts) + ' • ' + now.toLocaleTimeString(locale, tOpts);
      }, 1000);
    }
  }, 100);

  const now = new Date();
  const locale = getLanguage() === 'th' ? 'th-TH' : 'en-US';
  const initDate = now.toLocaleDateString(locale, { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric', timeZone: 'Asia/Bangkok' });
  const initTime = now.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit', second: '2-digit', timeZone: 'Asia/Bangkok', hour12: false });

  const currentLang = getLanguage();
  const otherLangLabel = currentLang === 'th' ? 'EN' : 'TH';

  return `
    <header class="app-header">
      <div class="header-inner">
        <div class="header-logo" onclick="location.hash='#/home'" style="cursor:pointer; display:flex; align-items:center; gap:8px;">
          <span class="logo-icon" style="font-size:1.8rem;">🔮</span>
          <div style="display:flex; flex-direction:column; justify-content:center;">
            <span style="line-height:1.2; font-weight:600;">${t('home_title')}</span>
            <span id="global-clock" style="font-size:0.75rem; color:var(--accent-gold); font-weight:normal; opacity:0.9; margin-top:2px;">
              ${initDate} • ${initTime}
            </span>
          </div>
        </div>
        <div class="header-user" style="display:flex; align-items:center; gap:var(--space-sm);">
          <button onclick="window.toggleLanguage()" class="btn btn-sm btn-outline text-xs" style="padding:4px 8px; border-radius:12px;">
            🌐 ${otherLangLabel}
          </button>
          ${user ? `
            <span class="text-sm text-muted" style="display:none;">${user.name}</span>
            <img class="header-avatar" 
                 src="${user.pictureUrl || 'https://ui-avatars.com/api/?name=U&background=9b59f0&color=fff&size=36'}" 
                 alt="${user.name}"
                 onerror="this.onerror=null; this.src='https://ui-avatars.com/api/?name=U&background=9b59f0&color=fff&size=36'" />
          ` : ''}
        </div>
      </div>
    </header>
  `;
}

export function renderBottomNav(activeTab = 'home') {
  const admin = isAdmin();

  const customerTabs = [
    { id: 'home', icon: '🏠', label: t('nav_home'), path: '/home' },
    { id: 'history', icon: '📋', label: t('nav_history'), path: '/history' },
    { id: 'profile', icon: '👤', label: t('nav_profile'), path: '/profile' }
  ];

  const adminTabs = [
    { id: 'admin-bookings', icon: '📋', label: 'การจอง', path: '/admin/bookings' },
    { id: 'admin-schedule', icon: '📅', label: 'ตารางเวลา', path: '/admin/schedule' },
    { id: 'admin-settings', icon: '⚙️', label: 'ตั้งค่า', path: '/admin/settings' },
    { id: 'admin-reports', icon: '📊', label: 'รายงาน', path: '/admin/reports' }
  ];

  const tabs = admin ? adminTabs : customerTabs;

  return `
    <nav class="bottom-nav">
      <div class="bottom-nav-inner">
        ${tabs.map(tab => `
          <button class="nav-item ${activeTab === tab.id ? 'active' : ''}" 
                  onclick="location.hash='#${tab.path}'"
                  id="nav-${tab.id}">
            <span class="nav-icon">${tab.icon}</span>
            <span>${tab.label}</span>
          </button>
        `).join('')}
      </div>
    </nav>
  `;
}
